export default __webpack_public_path__ + "static/media/ga.78339b7f.png";